import React, { useContext, useEffect, useState } from 'react';
import './TeamsAssignmentsListViewContent.css';
import {
  getTableIndex,
  getTableSizes,
  getTenant,
  isCurrentUserOnlyDepartmentManager,
} from '../../../hooks/helpers';
import useLicensingGroup from '../../../hooks/useLicensingGroup';
import TableSizeDropdown from '../../../components/TableSizeDropdown/TableSizeDropdown';
import AddLicensingUserGroup from '../../../components/AddLicensingUserGroup/AddLicensingUserGroup';
import {
  AppDataContext,
  IBLSpinLoader,
} from '@acilearning/ibl-web-react-common';
import EmptyTableDataInfographic from '../../../components/EmptyTableDataInfographic/EmptyTableDataInfographic';
import LicensingUsersInGroup from '../../../components/LicensingUsersInGroup/LicensingUsersInGroup';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useTeamsList from '../../../hooks/useTeamsList';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';
import { deleteTeam } from '../../../hooks/utils/teams';
import useLearnersTeamsAssignmentsList from '../../../hooks/useLearnersTeamsAssignmentsList';
import dayjs from 'dayjs';
import {
  archiveGroupAssignment,
  archiveTeamsAssignment,
  deleteCredentialsTeamsAssignments,
  deleteTeamsAssignments,
  markTeamsAssignmentsAsComplete,
} from '../../../hooks/utils/teamsAssignments';
import useGroupsTeamsAssignmentsList from '../../../hooks/useGroupsTeamsAssignmentsList';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';
import ConfirmationDialog from './ConfirmationDialog';
import ProgressCircle from './ProgressCircle';
import Select from 'react-select';
import useArchivedAssignments from '../../../hooks/useArchivedAssignments ';

const TeamsAssignmentsListViewContentCourse = ({ contentType = 'course' }) => {
  const { t } = useTranslation();
  const currentUserIsManager = isCurrentUserOnlyDepartmentManager();
  const TABLE_SIZES = getTableSizes();

  const [learnerSearch, setLearnerSearch] = useState('');
  const [learnerSize, setLearnerSize] = useState(TABLE_SIZES[0]);
  const [learnerPage, setLearnerPage] = useState(1);
  const [learnerRefresher, setLearnerRefresher] = useState(null);
  const [focusedLearnerForDeletion, setFocusedLearnerForDeletion] =
    useState('');

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deletionData, setDeletionData] = useState(null); // { entity, isGroup }

  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [completionData, setCompletionData] = useState(null); // similar to deletionData
  const [loadingComplete, setLoadingComplete] = useState(false);


  const [groupSearch, setGroupSearch] = useState('');
  const [groupSize, setGroupSize] = useState(TABLE_SIZES[0]);
  const [groupPage, setGroupPage] = useState(1);
  const [groupRefresher, setGroupRefresher] = useState(null);
  const [focusedGroupForDeletion, setFocusedGroupForDeletion] = useState('');
const [archivedView, setArchivedView] = useState({ label: "Learners", value: "learner" });
const [archivedSearch, setArchivedSearch] = useState('');
const [archivedPage, setArchivedPage] = useState(1);
const [archivedSize, setArchivedSize] = useState(TABLE_SIZES[0]);
const [archivedRefresher, setArchivedRefresher] = useState(null);

  const { setNotification } = useContext(AppDataContext);
  const { learners, learnersLoading, learnersPagination } =
    useLearnersTeamsAssignmentsList({
      contentType,
      search: learnerSearch,
      page: learnerPage,
      size: learnerSize,
      refresher: learnerRefresher,
    });
  const { groups, groupsLoading, groupsPagination } =
    useGroupsTeamsAssignmentsList({
      contentType,
      search: groupSearch,
      page: groupPage,
      size: groupSize,
      refresher: groupRefresher,
    });

    const { assignments: archivedAssignments, loading: archivedLoading, pagination: archivedPagination } =
  useArchivedAssignments({
    contentType,
    view: archivedView.value,
    search: archivedSearch,
    page: archivedPage,
    size: archivedSize,
    refresher: archivedRefresher,
    platformKey: getTenant(),
  });


// Dropdown options to select view
const archivedViewOptions = [
  { label: 'Learners', value: 'learner' },
  { label: 'Groups', value: 'group' },
];



  const paginateLearners = ({ selected }) => {
    setLearnerPage(selected + 1);
  };
  const paginateGroups = ({ selected }) => {
    setGroupPage(selected + 1);
  };
  const paginateArchived = ({ selected }) => {
  setArchivedPage(selected + 1);
};

  const handleMarkAsCompleteClick = (entity, isGroup) => {
  setCompletionData({
    entity,
    isGroup,
  });
  setShowCompleteDialog(true);
  };
  const executeMarkAsComplete = async () => {
  if (!completionData) return;

  setLoadingComplete(true);

  // Use the utility function!
  const wasCompleted = await markTeamsAssignmentsAsComplete(
    completionData.entity,
    contentType,
    completionData.isGroup
  );

  if (wasCompleted) {
    setNotification({
      msg: `${completionData.isGroup
        ? completionData.entity.group_name
        : completionData.entity.name
      } ${contentType} marked as complete successfully.`,
      success: true,
    });
    completionData.isGroup
      ? setGroupRefresher(Date.now())
      : setLearnerRefresher(Date.now());
    setShowCompleteDialog(false);
  } else {
    setNotification({
      msg: `An error occurred during marking as complete.`,
      success: false,
    });
  }

  setLoadingComplete(false);
};




  const confirmDelete = (entity, isGroup = false) => {
  setDeletionData({ entity, isGroup });
  console.log("Deletion data " + JSON.stringify(deletionData, null,2));
  setShowDeleteDialog(true);
};

const executeDelete = async () => {
  const { entity, isGroup } = deletionData;
  if (!entity) return;

  isGroup 
    ? setFocusedGroupForDeletion(entity?.id)
    : setFocusedLearnerForDeletion(entity?.id);

  const platformKey = getTenant();

  let success = false;

  try {
    if (contentType === 'credential') {
      // Credentials still deleted
      success = await deleteCredentialsTeamsAssignments(entity.entity_id);
    } else if (contentType === 'course') {
      if (isGroup) {
        // Archive group assignments using the new archiveGroupAssignment API
        success = await archiveGroupAssignment(entity.id, platformKey);
      } else {
        // Archive learner/course assignments using existing API
        success = await archiveTeamsAssignment(entity.id, platformKey);
      }
    } else {
      // For other content, fallback to legacy deleteTeamsAssignments API
      success = await deleteTeamsAssignments(entity.id, contentType, isGroup);
    }
  } catch (error) {
    console.error('Error during archive/delete operation:', error);
    success = false;
  }

  if (success) {
    setNotification({
      msg: `${isGroup ? entity?.group_name : entity?.name} ${contentType} assignment archived successfully.`,
      success: true,
    });
    if (isGroup) setGroupRefresher(Date.now());
    else setLearnerRefresher(Date.now());
    setArchivedRefresher(Date.now());
  } else {
    setNotification({
      msg: `An error occurred during the assignment archival.`,
      success: false,
    });
  }

  if (isGroup) setFocusedGroupForDeletion(null);
  else setFocusedLearnerForDeletion(null);
  setShowDeleteDialog(false);
  setDeletionData(null);
};


  const getContentName = (singleAssignmentData) => {
    switch (contentType) {
      case 'program':
        return singleAssignmentData?.program_name;
      case 'pathway':
        return singleAssignmentData?.pathway_name;
      case 'credential':
        return singleAssignmentData?.credential_name;
      default:
        return singleAssignmentData?.course_name;
    }
  };

  return (
    <>
      <div className="p-row r-r">
        <div className="div-block-204 f-w">
          <div className="div-block-183">
            <div className="div-block-205">
              <div className="div-block-206" />
              <div className="text-block-113">
                Assignments |{' '}
                <span className={'capitalize'}>{contentType}</span>s
              </div>
            </div>
            <div className="div-block-308">
              <Link
                to={`/teams/assignments/add-new/${contentType}s`}
                className="link-block-22 w-inline-block"
              >
                <div
                  data-w-id="2e311dd0-e1c2-0ab6-f2a1-1e492e5123a6"
                  className="div-block-207 first active follow-user alt-btn issue-popup"
                >
                  <div className="text-block-111">Assign {contentType}</div>
                </div>
              </Link>
            </div>
          </div>
          <div react-component="CourseTable" className="table_cont-2">
            <div className="div-block-217">
              <div className="div-block-169">
                <div>
                  <div
                    prop-data-value-tablename="Courses"
                    prop-data-names="tableName"
                    className="text-block-135"
                  >
                    Learners Assignments
                    <br />
                  </div>
                </div>
              </div>
              <div className="div-block-169">
                <div className="div-block-171">
                  <div className="sm">Show</div>
                  <div className="form-block w-form">
                    <TableSizeDropdown
                      setSize={setLearnerSize}
                      setPage={setLearnerPage}
                    />
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="sm">entries</div>
                </div>
                <div className="div-block-171">
                  <div className="sm">Search:</div>
                  <div className="form-block w-form">
                    <form
                      id="email-form-2"
                      name="email-form-2"
                      data-name="Email Form 2"
                      method="get"
                      data-wf-page-id="66e1c2afd7d305ab933f7a97"
                      data-wf-element-id="4386085a-1eef-af03-c6b1-7a5a39f298f9"
                    >
                      <input
                        className="input w-input"
                        data-name="Field 3"
                        id="field-3"
                        maxLength={256}
                        name="field-3"
                        placeholder=""
                        required=""
                        type="text"
                        value={learnerSearch}
                        onChange={(e) => {
                          setLearnerPage(1);
                          setLearnerSearch(e?.target?.value);
                        }}
                      />
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div react-component="table" className="table">
                <div className="th">
                  <div className="tc _5">
                    <div className="sm">#</div>
                  </div>
                  <div className="tc _15">
                    <div className="w_sort">
                      
                      <div className="sm">Learner</div>
                    </div>
                  </div>
                  <div className="tc tcell _11">
                    <div className='sm'>Progress</div>
                  </div>
                  <div className="tc _30">
                    <div className="w_sort">
                      
                      <div className="sm">Assigned {contentType}</div>
                    </div>
                  </div>
                  <div className="tc _20">
                    <div className="w_sort">
                      
                      <div className="sm">Created at</div>
                    </div>
                  </div>
                   <div className='tc tcell _30'>

                   </div>
                </div>
                {learnersLoading ? (
                  <IBLSpinLoader
                    containerHeight={'200px'}
                    size={20}
                    color={'white'}
                  />
                ) : learners.length > 0 ? (
                  learners.map((learner, index) => (
                    <div className="tr">
                      <div className="tc tcell _5">
                        <div className="m">
                          {getTableIndex(index, learnerPage, learnerSize)}
                        </div>
                      </div>
                      <div
                        data-w-id="4386085a-1eef-af03-c6b1-7a5a39f2991c"
                        className="tc tcell _15"
                      >
                        <img
                          src="/images/female20091023302387177.jpeg"
                          loading="lazy"
                          alt
                          className="r-i hidden"
                        />
                        <div className="tl-2 np">{learner?.name || learner?.username}</div>
                      </div>

                      <div className="tc tcell _11">
    <ProgressCircle progress={learner.completion_percentage || 0} />
  </div>
                      <div
                        data-w-id="4386085a-1eef-af03-c6b1-7a5a39f2991c"
                        className="tc tcell _30"
                      >
                        <img
                          src="/images/female20091023302387177.jpeg"
                          loading="lazy"
                          alt
                          className="r-i hidden"
                        />
                        <div className="tl-2 np">{getContentName(learner)}</div>
                      </div>
                      <div className="tc tcell _20">
                        <div className="m small">
                          {learner?.created
                            ? dayjs(learner?.created).format('DD MMM YYYY')
                            : '-'}
                        </div>
                      </div>

                      <div className='tc tcell _30'>
                        <div className="assignment-actions">
                        {learner.completion_percentage === 100 ? (
                            <span className="completed-label">Completed</span>) 
                            : (
                            <button className="mark-complete-btn" 
                            onClick={() => handleMarkAsCompleteClick(learner, false)}
                            >
                                Mark as Complete
                            </button>
                        )}
                        <button
                        className="delete-btn"
                        onClick={() => confirmDelete(learner)}
                        disabled={focusedLearnerForDeletion === learner?.id}
                        >
                            {focusedLearnerForDeletion === learner?.id ? (
                              <IBLSpinLoader size={20} color={'#FFF'} />
                            ) : (
                              'Archive'
                            )}
                            </button>
                          </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <EmptyTableDataInfographic />
                )}
                <div className="tf pagination-container">
                  <div className="div-block-289">
                    <div className="info-3">
                      {t('Showing')} {(learnerPage - 1) * learnerSize + 1}{' '}
                      {t('to')}{' '}
                      {Math.min(
                        learnerPage * learnerSize,
                        learnersPagination.totalItems
                      )}{' '}
                      {t('of')} {learnersPagination.totalItems}
                    </div>
                    <ReactPaginate
                      onPageChange={paginateLearners}
                      pageCount={learnersPagination.totalPages}
                      forcePage={learnerPage - 1}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      containerClassName={'pagination'}
                      pageLinkClassName={'page-number'}
                      previousLinkClassName={'page-number'}
                      nextLinkClassName={'page-number'}
                      activeLinkClassName={'active'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div react-component="CourseTable" className="table_cont-2">
            <div className="div-block-217">
              <div className="div-block-169">
                <div>
                  <div
                    prop-data-value-tablename="Courses"
                    prop-data-names="tableName"
                    className="text-block-135"
                  >
                    Groups Assignments
                    <br />
                  </div>
                </div>
              </div>
              <div className="div-block-169">
                <div className="div-block-171">
                  <div className="sm">Show</div>
                  <div className="form-block w-form">
                    <TableSizeDropdown
                      setSize={setGroupSize}
                      setPage={setGroupPage}
                    />
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="sm">entries</div>
                </div>
                <div className="div-block-171">
                  <div className="sm">Search:</div>
                  <div className="form-block w-form">
                    <form
                      id="email-form-2"
                      name="email-form-2"
                      data-name="Email Form 2"
                      method="get"
                      data-wf-page-id="66e1c2afd7d305ab933f7a97"
                      data-wf-element-id="4386085a-1eef-af03-c6b1-7a5a39f298f9"
                    >
                      <input
                        className="input w-input"
                        data-name="Field 3"
                        id="field-3"
                        maxLength={256}
                        name="field-3"
                        placeholder=""
                        required=""
                        type="text"
                        value={groupSearch}
                        onChange={(e) => {
                          setGroupPage(1);
                          setGroupSearch(e?.target?.value);
                        }}
                      />
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div react-component="table" className="table">
                <div className="th">
                  <div className="tc _5">
                    <div className="sm">#</div>
                  </div>
                  <div className="tc _15">
                    <div className="w_sort">
                      
                      <div className="sm">Group</div>
                    </div>
                  </div>
                  <div className="tc tcell _11">
                    <div className='sm'>Average Progress</div>
                  </div>
                  <div className="tc _30">
                    <div className="w_sort">
                      
                      <div className="sm">Assigned {contentType}</div>
                    </div>
                  </div>
                  <div className="tc _20">
                    <div className="w_sort">
                      
                      <div className="sm">Created at</div>
                    </div>
                  </div>
                  <div className='tc tcell _30'>
                    
                   </div>
                </div>
                {groupsLoading ? (
                  <IBLSpinLoader
                    containerHeight={'200px'}
                    size={20}
                    color={'white'}
                  />
                ) : groups.length > 0 ? (
                  groups.map((learner, index) => (
                    <div className="tr">
                      <div className="tc tcell _5">
                        <div className="m">
                          {getTableIndex(index, groupPage, groupSize)}
                        </div>
                      </div>
                      <div
                        data-w-id="4386085a-1eef-af03-c6b1-7a5a39f2991c"
                        className="tc tcell _15"
                      >
                        <img
                          src="/images/female20091023302387177.jpeg"
                          loading="lazy"
                          alt
                          className="r-i hidden"
                        />
                        <div className="tl-2 np">{learner?.group_name}</div>
                      </div>
                      <div className="tc tcell _11">
    <ProgressCircle progress={learner.average_completion_percentage || 0} />
  </div>
                      <div
                        data-w-id="4386085a-1eef-af03-c6b1-7a5a39f2991c"
                        className="tc tcell _30"
                      >
                        <img
                          src="/images/female20091023302387177.jpeg"
                          loading="lazy"
                          alt
                          className="r-i hidden"
                        />
                        <div className="tl-2 np">{getContentName(learner)}</div>
                      </div>
                      <div className="tc tcell _20">
                        <div className="m small">
                          {learner?.created
                            ? dayjs(learner?.created).format('DD MMM YYYY')
                            : '-'}
                        </div>
                      </div>

                    <div className='tc tcell _30'>
                        <div className="assignment-actions">
                        {learner.average_completion_percentage === 100 ? (
                            <span className="completed-label">Completed</span>
                        ) : (
                        <button className="mark-complete-btn" 
                        onClick={() => handleMarkAsCompleteClick(learner, true)}>
                            Mark as Complete
                        </button>
                    )}
                    
                    <button className="delete-btn" 
                    onClick={() => confirmDelete(learner, true)} 
                    disabled={focusedGroupForDeletion === learner?.id}>
                        {focusedGroupForDeletion === learner?.id ? (
                            <IBLSpinLoader size={20} color={'#FFF'} />
                        ) : (
                            'Archive'
                        )}
                    </button>
                </div>
                    
                   </div>
                    </div>
                  ))
                ) : (
                  <EmptyTableDataInfographic />
                )}
                <div className="tf pagination-container">
                  <div className="div-block-289">
                    <div className="info-3">
                      {t('Showing')} {(groupPage - 1) * groupSize + 1} {t('to')}{' '}
                      {Math.min(
                        groupPage * groupSize,
                        groupsPagination.totalItems
                      )}{' '}
                      {t('of')} {groupsPagination.totalItems}
                    </div>
                    <ReactPaginate
                      onPageChange={paginateGroups}
                      pageCount={groupsPagination.totalPages}
                      forcePage={groupPage - 1}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      containerClassName={'pagination'}
                      pageLinkClassName={'page-number'}
                      previousLinkClassName={'page-number'}
                      nextLinkClassName={'page-number'}
                      activeLinkClassName={'active'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div react-component="CourseTable" className="table_cont-2">
            <div className="div-block-217">
              <div className="div-block-169">
                <div>
                  <div
                    prop-data-value-tablename="Courses"
                    prop-data-names="tableName"
                    className="text-block-135"
                  >
                    Archived Assignments
                    <br />
                  </div>
                </div>
              </div>
              <div className="div-block-169">
                <div className="div-block-171">
                  <div className="sm">Show</div>
                  <div className="form-block w-form">
                    <TableSizeDropdown setSize={setArchivedSize} setPage={setArchivedPage} />
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="sm">entries</div>
                  <div className="archived-selector-container" style={{ width: 160 }}>
  <Select
    className="react-select-container"
    classNamePrefix="react-select"
    options={archivedViewOptions}
    value={archivedView}
    // onChange={setArchivedView}
    onChange={option => {
    setArchivedView(option);   // Set the new view (Learners or Groups)
    setArchivedPage(1);        // Reset the page to 1
  }}
    placeholder="Select view"
    styles={{
      control: (base) => ({
        ...base,
        borderColor: '#000',
        '&:hover': { borderColor: '#000' },
        boxShadow: 'none',
      }),
      indicatorsContainer: (base) => ({
        ...base,
        color: '#000',
      }),
    }}
  />
</div>

                </div>
                <div className="div-block-171">
                  <div className="sm">Search:</div>
                  <div className="form-block w-form">
                    <form
                      id="email-form-2"
                      name="email-form-2"
                      data-name="Email Form 2"
                      method="get"
                      data-wf-page-id="66e1c2afd7d305ab933f7a97"
                      data-wf-element-id="4386085a-1eef-af03-c6b1-7a5a39f298f9"
                    >
                      {/* <input
                        className="input w-input"
                        data-name="Field 3"
                        id="field-3"
                        maxLength={256}
                        name="field-3"
                        placeholder=""
                        required=""
                        type="text"
                        value={groupSearch}
                        onChange={(e) => {
                          setGroupPage(1);
                          setGroupSearch(e?.target?.value);
                        }}
                      /> */}
<input
  className="input w-input"
  placeholder={archivedView.value === 'learner' ? "Search by assignment or learner" : "Search by assignment or group"}
  value={archivedSearch}
  onChange={e => {
    setArchivedSearch(e.target.value);
    setArchivedPage(1);
  }}
/>

                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div react-component="table" className="table">
                <div className="th">
                  <div className="tc _5">
                    <div className="sm">#</div>
                  </div>
                  <div className="tc _15">
                    <div className="w_sort">
                      
                      <div className="sm">{archivedView.value === 'learner' ? 'Learner' : 'Group'}</div>
                    </div>
                  </div>
                  <div className="tc tcell _11">
                    <div className='sm'>{archivedView.value === 'learner' ? 'Progress' : 'Average Progress'}</div>
                  </div>
                  <div className="tc _30">
                    <div className="w_sort">
                      
                      <div className="sm">Assigned {contentType}</div>
                    </div>
                  </div>
                  <div className="tc _20">
                    <div className="w_sort">
                      
                      <div className="sm">Archived On</div>
                    </div>
                  </div>
                  <div className='tc tcell _30'>
                    
                   </div>
                </div>
               {archivedLoading ? (
  <IBLSpinLoader containerHeight="200px" size={20} color="white" />
) : archivedAssignments && archivedAssignments.length > 0 ? (
  archivedAssignments.map((item, index) => (
    <div className="tr" key={item.id}>
      <div className="tc _5">{(archivedPage - 1) * archivedSize + index + 1}</div>
      
      <div className="tc _15">
        {archivedView.value === 'learner' ? item.name || item.username : item.group_name}
      </div>
      
      <div className="tc _11">
        <ProgressCircle progress={archivedView.value === 'learner' ? (item.completion_percentage ?? 0) : (item.average_completion_percentage ?? 0)} />
      </div>
      
      <div className="tc _30">
        {item.course_name}
      </div>
      
      <div className="tc _20">
        {item.modified ? dayjs(item.modified).format('DD MMM YYYY') : '-'}
      </div>
      
      <div className="tc _30">
        {/* Placeholder if you have actions (e.g. delete) */}
      </div>
    </div>
  ))
) : (
  <EmptyTableDataInfographic />
)}

                <div className="tf pagination-container">
                  <div className="div-block-289">
                    <div className="info-3">
                      {t('Showing')} {(groupPage - 1) * groupSize + 1} {t('to')}{' '}
                      {Math.min(
                        groupPage * groupSize,
                        groupsPagination.totalItems
                      )}{' '}
                      {t('of')} {groupsPagination.totalItems}
                    </div>
                    {/* <ReactPaginate
                      onPageChange={paginateGroups}
                      pageCount={groupsPagination.totalPages}
                      forcePage={groupPage - 1}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      containerClassName={'pagination'}
                      pageLinkClassName={'page-number'}
                      previousLinkClassName={'page-number'}
                      nextLinkClassName={'page-number'}
                      activeLinkClassName={'active'}
                    /> */}
                    <ReactPaginate
  onPageChange={paginateArchived}
  pageCount={archivedPagination?.totalPages || 0}
  forcePage={archivedPage - 1}
  previousLabel="Prev"
  nextLabel="Next"
  containerClassName="pagination"
  pageLinkClassName="page-number"
  previousLinkClassName="page-number"
  nextLinkClassName="page-number"
  activeLinkClassName="active"
/>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showDeleteDialog && (
            <DeleteConfirmationDialog 
            visible={showDeleteDialog}
            description={`Are you sure you want to archive this assignment?`}
            name={
                deletionData?.isGroup
                ? deletionData?.entity?.group_name
                : deletionData?.entity?.name
            }
            onCancel={() => setShowDeleteDialog(false)}
            onConfirm={executeDelete}
            loading={
            deletionData?.isGroup
            ? focusedGroupForDeletion === deletionData?.entity?.id
            : focusedLearnerForDeletion === deletionData?.entity?.id
            }
        />
    )}
    </div>

        {showCompleteDialog && (
            <ConfirmationDialog 
            visible={showCompleteDialog}
            name={
                completionData?.isGroup
                ? completionData?.entity?.group_name
                : completionData?.entity?.name
            }
            description={`The ${!completionData?.isGroup ? 'learner' : 'group'} ${
                completionData?.isGroup
                ? completionData?.entity?.group_name
                : completionData?.entity?.username
            } has completed ${
                completionData?.isGroup ? completionData?.entity?.average_completion_percentage : 
                completionData?.entity?.completion_percentage ?? 0}% of the course. Do you want to mark it as complete?`}
            onCancel={() => setShowCompleteDialog(false)}
            onConfirm={executeMarkAsComplete}
            loading={loadingComplete}
            confirmButtonLabel="Confirm"
       />
    )}
    </>
  );
};

export default TeamsAssignmentsListViewContentCourse;
